/**
 * Detect whether the current user is an external agent who hasn't
 * finished training (MRG-281). When true, data sources should annotate
 * outgoing GETs with ``?training_mode=true`` so the API returns
 * fixtures.
 *
 * Defense in depth: we also require the agent to have signed the
 * Marketplace Agent Agreement (`external_agent_terms_accepted_at` is
 * non-null). The root-level redirect in `__root.tsx` already bounces
 * pre-ToS agents back to `/onboarding`, but if that redirect ever races
 * with the route render — or a legacy user slips through — we still
 * want the welcome modal + driver.js tour to stay dormant until the
 * agreement is in place.
 */

import { useUserProfile } from '@/common/hooks/useUserProfile'

export function useAgentTrainingMode(): boolean {
  const { data, needsTraining } = useUserProfile()
  const isExternalAgent = data?.profile?.agent_type === 'external'
  const tosSigned = data?.profile?.external_agent_terms_accepted_at != null
  return isExternalAgent && tosSigned && needsTraining
}
